export function formatWeight(weight) {
  return weight.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}
